import ztComponent from './ztModal.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
